<span class="icon-inline" v-tooltip.bottom="tooltipOptions">
  <ChessMarseilleSvg
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    :style="svgStyle"
  />
</span>
